module.exports = __webpack_public_path__ + "img/sig01.768a1f9b.png";